module.exports = __webpack_public_path__ + "static/media/Asset3.db20f359.png";